import PayPerViewPop from "components/PayPerViewPop";
import { decodeHtmlEntities } from "constant/htmlEntities";
import Calendar from "react-calendar";
import React, { useEffect, useState } from "react";
import { BsCalendarEvent } from "react-icons/bs";
import { FiCheckCircle, FiMail } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { AddToCalendarButton } from "add-to-calendar-button-react";
import PaymentService from "services/PaymentService";
import { RouteName } from "constant/routeNames";
import {
  formatToLocalDateString,
  getFormattedLocalDate,
} from "utils/timeFunctions";
import { Helmet } from "react-helmet-async";

function PayperviewSuccesPage() {
  const navigate = useNavigate();
  const [event, setEvent] = useState<any>();
  const [fetching, setFetching] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ppv_e = queryParams.get("ppv_e");
  const payment_intent = queryParams.get("payment_intent");
  const redirect_status = queryParams.get("redirect_status");

  const getEvent = async () => {
    try {
      const response = await PaymentService.getEventByIntense(payment_intent);
      // console.log("response getEvent ", response.data);
      setEvent(response.data);
      console.log("response getEvent ", response.data);
      setFetching(false);
    } catch (error) {
      setFetching(false);
      console.error("Error during fetching event by payment_intent:", error);
    }
  };
  //get a link
  const baseUrl = window.location.origin;
  const currentUrl =
    baseUrl +
    `${RouteName.PayPerView.replace(
      "*",
      RouteName.PayperviewDetails.replace(":slug", event?.slug)
    )}`;

  // event_formatted_date isn't always populated on the API side (same
  // gap PayPerViewCard.tsx already works around) — when it's missing this
  // fell through to NaN hours/minutes, which produced an invalid "NaN:NaN"
  // start time for the Add to Calendar button and made it fail to render.
  const eventStartTime = getFormattedLocalDate(
    event?.event_formatted_date || event?.start_date_time || event?.date_time,
  );
  const eventEndTime = getFormattedLocalDate(event?.end_date_time);

  const dateTimeString = event?.start_date_time;
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Months are zero-based, so add 1
  const day = date.getDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  // const oneHourBefore = new Date();
  // oneHourBefore.setUTCHours(hours - 4);
  // oneHourBefore.setUTCMinutes(minutes);

  const startDate = `${year}-${month < 10 ? "0" : ""}${month}-${
    day < 10 ? "0" : ""
  }${day}`;

  const startTime = `${eventStartTime?.hours < 10 ? "0" : ""}${
    eventStartTime?.hours
  }:${eventStartTime?.minutes < 10 ? "0" : ""}${eventStartTime?.minutes}`;

  const EndTime = `${eventEndTime?.hours < 10 ? "0" : ""}${
    eventEndTime?.hours
  }:${eventEndTime?.minutes < 10 ? "0" : ""}${eventEndTime?.minutes}`;

  const isNextDay =
    eventStartTime?.year !== eventEndTime?.year ||
    eventStartTime?.month !== eventEndTime?.month ||
    eventStartTime?.date !== eventEndTime?.date;

  const formattedEndTime = isNextDay ? "23:59" : EndTime;

  // console.log("date", startDate);
  // console.log("endformated", formattedEndTime);
  // console.log("start",startTime);

  useEffect(() => {
    if (payment_intent) {
      getEvent();
    }
  }, [payment_intent]);

  useEffect(() => {
    if (ppv_e) {
      try {
        // Decode the JWT token to get the original data
        const decodedData = jwt_decode(ppv_e) as any;
        const decodedPpvEvent = decodedData.ppvEvent;
        setEvent(decodedPpvEvent);
      } catch (error) {
        console.error("Error decoding ppv_e:", error);
      }
    }
  }, [ppv_e]);

  if (redirect_status === "failed") {
    navigate("/ppv/checkout", { state: { ppv_event: event } });
  }
  console.log("event checking ", event);
  // console.log("event time", event?.start_date_time);

  const handleGoHome = async () => {
    navigate(RouteName.PayPerView.replace("/*", ""));
  };

  return (
    <>
      <Helmet>
        <title>
          {event?.title
            ? `${event?.title} - Successfully purchased`
            : "AYOZAT Payperview"}
        </title>
        <meta
          name="description"
          content="Experience exclusive content and events on demand with our Pay-Per-View service."
        />
        {/* <link rel="canonical" href={`${FE_URL}/ppv`} /> */}
        <meta property="og:title" content="AYOZAT Payperview" />
        <meta
          property="og:description"
          content="Experience exclusive content and events on demand with our Pay-Per-View service."
        />
        {/* <meta property="og:image:secure_url" content="https://ayozat.co.uk/logo192.png" /> */}
        <meta property="og:image" content="https://ayozat.co.uk/logo192.png" />
        {/* <meta property="og:url" content={`${FE_URL}/ppv`} /> */}
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AYOZAT Payperview" />
        <meta
          name="twitter:description"
          content="Experience exclusive content and events on demand with our Pay-Per-View service."
        />
        <meta name="twitter:image" content="https://ayozat.co.uk/logo192.png" />
        <meta name="twitter:site" content="AYOZAT Payperview" />
        {/* <meta name="twitter:url" content={`${FE_URL}/ppv`} /> */}
      </Helmet>

      {!fetching && redirect_status === "succeeded" && (
        <div className="w-[80%] max-lg:w-[95%] mx-auto max-sm:mb-20 overflow-hidden bg-gray-900 border border-gray-800 shadow-2xl rounded-2xl">
          <div
            className="relative min-h-[600px] max-sm:min-h-[520px] flex items-end"
            // bannerImage falls back to a placeholder path on the API side
            // that isn't always uploaded/present for every event, which
            // left this area blank when it 404'd. thumbnailImage is
            // populated for every event (same fallback chain already used
            // in PPVReplayVideoPlayerPage/PPVVideoPlayer), and the solid
            // background color is a last-resort so this never renders as
            // an empty gap even if both image URLs fail to load.
            style={{
              backgroundColor: "#1a1a1a",
              backgroundImage: `url(${event?.bannerImage || event?.thumbnailImage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            {/* scrim so the overlaid text stays readable against any banner */}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10" />

            <div className="relative w-full px-8 py-10 max-sm:px-6 max-sm:py-8">
              <span className="flex items-center justify-center w-14 h-14 mb-5 rounded-full bg-[#f30543]/15 text-[#f30543]">
                <FiCheckCircle size={28} />
              </span>

              <h1 className="text-[32px] max-lg:text-[24px] leading-tight font-bold text-white">
                Thank you for your purchase!
              </h1>

              <div className="flex items-start gap-2 mt-4 text-gray-300">
                <FiMail className="mt-1 shrink-0" size={16} />
                <p>
                  <span className="font-semibold text-white">
                    Check Your Inbox —
                  </span>{" "}
                  we've just sent you an email with details about the event
                </p>
              </div>

              <h2 className="w-full mt-6 font-rubik text-white text-[24px] max-sm:text-[20px] font-semibold">
                {decodeHtmlEntities(event?.title)}
              </h2>

              <div className="mt-4">
                {event?.rentable ? (
                  <span className="inline-block px-4 py-1 text-sm font-semibold text-white rounded-full bg-[#f30543]">
                    Available for Rent: {event?.rent_duration}{" "}
                    {event?.rent_duration > 1 ? "Days" : "Day"}
                  </span>
                ) : (
                  <span className="inline-block px-4 py-1 text-sm font-semibold text-white rounded-full bg-[#f30543]">
                    {formatToLocalDateString(
                    event?.event_formatted_date || event?.start_date_time || event?.date_time,
                  )}
                  </span>
                )}
              </div>

              {!event?.rentable && (
                <p className="w-full max-w-md mt-6 text-gray-300 text-[15px]">
                  You can set a calendar reminder to make sure you will not
                  miss the event
                </p>
              )}

              <div className="flex flex-wrap items-center gap-3 mt-8 max-sm:justify-center">
                {!event?.rentable && (
                  <AddToCalendarButton
                    name={`${event?.title} - AYOZAT PPV`}
                    startDate={startDate}
                    startTime={startTime}
                    endTime={formattedEndTime}
                    // name="[Reminder] Test the Add to Calendar Button"
                    // startDate="2023-10-24"
                    // startTime="10:15"
                    // endTime="23:30"
                    timeZone={
                      Intl.DateTimeFormat().resolvedOptions().timeZone
                    }
                    location="World Wide Web"
                    description={`${event?.description}\nFor more Details: ${currentUrl}`}
                    options={[
                      "Apple",
                      "Outlook.com",
                      "Yahoo",
                      "Google",
                      "iCal",
                    ]}
                    recurrence=""
                    lightMode="dark"
                    buttonStyle="round"
                  />
                )}
                <button
                  className="px-8 py-3 font-semibold text-center text-white transition-colors rounded-full bg-[#f30543] hover:bg-[#d40339] max-sm:w-full"
                  onClick={handleGoHome}
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {fetching && (
        <div className="flex items-center rounded-lg justify-center mx-auto bg-gray-600 max-sm:mb-20 w-[80%] max-lg:w-[95%] max-sm:block animate-pulse h-96"></div>
      )}
    </>
  );
}

export default PayperviewSuccesPage;
